import { polyfills } from './polyfills/polyfills';
import { yall } from './lib/yall-v3.1.6';
import menu from './modules/menu';
import mobileMenu from './modules/mobile-menu';
import { toggleButton } from './modules/toggle-button';
import { qep } from './modules/list-filtration';
import 'what-input';
import { cookieModule } from './modules/cookies';
import { video } from './modules/video';
import { phoneListExcel } from './modules/phole-table-excel';
import { accordion } from './modules/accordion';

export const start = () => {
  console.log('App loaded');

  qep().init();
  cookieModule.init();
  video('.js-c-video');

  const jsListMore = document.querySelector('.js-list-more');

  const listMoreAllContainers = document.querySelectorAll(
    '.list-more-container',
  );

  const jsReadMoreText = document.querySelector('.js-show-more');
  const jsReadLessText = document.querySelector('.js-show-less');

  if (jsListMore) {
    jsListMore.addEventListener('click', function (e) {
      listMoreAllContainers.forEach(listContainer =>
        listContainer.classList.toggle('show-more'),
      );
      jsListMore.classList.toggle('open');
      jsReadMoreText.classList.toggle('hide');
      jsReadLessText.classList.toggle('hide');
    });
  }

  document.querySelector('.menu-bar') ? menu() : null;
  toggleButton();
  mobileMenu('.js-hamburger');
  phoneListExcel();
  accordion();

  yall({
    events: {
      load: function (event) {
        const element = event.target;

        if (!element.classList.contains('lazy') && element.nodeName == 'IMG') {
          element.classList.add('lazy--loaded');

          if (
            !isObjectFitSupported &&
            element.classList.contains('js-object-fit')
          )
            objectFitPolyfill(element);
        }
      },
    },
    observeChanges: true,
  });
};

export const app = () => {
  if (!polyfills) {
    start();
  } else {
    Promise.all([...polyfills])
      .then(_ => {
        try {
          start();
        } catch (error) {
          console.error('Failed to start the app', error);
        }
      })
      .catch(error => {
        console.error('Failed fetching polyfills', error);
      });
  }
};

// eslint-disable-next-line no-unused-expressions
document.readyState !== 'loading'
  ? app()
  : document.addEventListener('DOMContentLoaded', app);
